import React from 'react';
import './TablaPedidos.css';

const TablaPedidos = ({ pedidos, choferes, onActualizarPedido, onVerDetalles, onEliminarPedido, allowStatusChange = true }) => {
  const getStatusClass = (estatus) => {
    switch (estatus) {
      case 'entregado':
        return 'status-entregado';
      case 'en_preparacion':
        return 'status-preparacion';
      case 'ruta':
        return 'status-ruta';
      case 'cancelado':
        return 'status-cancelado';
      default:
        return 'status-default';
    }
  };

  const getStatusText = (estatus) => {
    switch (estatus) {
      case 'en_preparacion':
        return 'En Preparación';
      case 'ruta':
        return 'En Camino';
      case 'entregado':
        return 'Entregado';
      case 'cancelado':
        return 'Cancelado';
      default:
        return estatus;
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    
    const dateStr = String(dateString).trim();
    
    // Extraer fecha directamente del formato YYYY-MM-DD para evitar problemas de zona horaria
    if (dateStr.length >= 10 && dateStr[4] === '-' && dateStr[7] === '-') {
      const year = dateStr.substring(0, 4);
      const month = dateStr.substring(5, 7);
      const day = dateStr.substring(8, 10);
      return `${day}/${month}/${year}`;
    }
    
    // Fallback: usar Date con UTC si no es formato YYYY-MM-DD
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return '-';
      const d = String(date.getUTCDate()).padStart(2, '0');
      const m = String(date.getUTCMonth() + 1).padStart(2, '0');
      const y = date.getUTCFullYear();
      return `${d}/${m}/${y}`;
    } catch (e) {
      return '-';
    }
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };

  const formatCurrency = (amount) => {
    if (!amount) return '$0.00';
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN'
    }).format(amount);
  };

  const handleStatusChange = async (pedidoId, nuevoEstatus) => {
    try {
      await onActualizarPedido(pedidoId, { estatus: nuevoEstatus });
    } catch (error) {
      console.error('Error al actualizar estatus:', error);
    }
  };

  if (pedidos.length === 0) {
    return (
      <div className="tabla-pedidos">
        <div className="no-data">
          <p>No hay pedidos registrados</p>
        </div>
      </div>
    );
  }

  return (
    <div className="tabla-pedidos">
      <div className="table-container">
        <table className="pedidos-table">
          <thead>
            <tr>
              <th>ID Pedido</th>
              <th>Cliente</th>
              <th>Repartidor</th>
              <th>Fecha</th>
              <th>Importe</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {pedidos.map((pedido) => (
              <tr key={pedido.id}>
                <td className="pedido-id">{pedido.numeroDocumento || pedido.id}</td>
                <td className="cliente">{pedido.cliente}</td>
                <td className="repartidor">{pedido.chofer}</td>
                <td className="fecha">
                  {pedido.fechaCreacion 
                    ? formatDateTime(pedido.fechaCreacion)
                    : formatDate(pedido.fechaCompra)
                  }
                </td>
                <td className="importe">{formatCurrency(pedido.importe)}</td>
                <td className="estado">
                  <span className={`status-badge ${getStatusClass(pedido.estatus)}`}>
                    {getStatusText(pedido.estatus)}
                  </span>
                </td>
                <td className="acciones">
                  <div className="action-buttons">
                    <button className="btn-details"
                      onClick={() => onVerDetalles ? onVerDetalles(pedido) : null}
                      title="Ver detalles y editar pedido"
                    >
                      Editar
                    </button>
                    {allowStatusChange && (
                      <select 
                        className="status-select"
                        value={pedido.estatus}
                        onChange={(e) => handleStatusChange(pedido.id, e.target.value)}
                      >
                        <option value="en_preparacion">En Preparación</option>
                        <option value="ruta">En Ruta</option>
                        <option value="entregado">Entregado</option>
                        <option value="cancelado">Cancelado</option>
                      </select>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Paginación */}
      <div className="pagination">
        <button className="pagination-btn" disabled>
          ← Anterior
        </button>
        <span className="pagination-info">
          Mostrando 1-{pedidos.length} de {pedidos.length} pedidos
        </span>
        <button className="pagination-btn" disabled>
          Siguiente →
        </button>
      </div>
    </div>
  );
};

export default TablaPedidos;
